/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://qxhty6bqmvfdfdoapqzwsgna3e.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-il7nrdgftbh6vl22hdisiswzbu",
    "aws_cognito_identity_pool_id": "ap-south-1:a4af3aa5-6c34-47c9-9dea-285ba0bdfd7c",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_UEomR6Y5Q",
    "aws_user_pools_web_client_id": "10r0a8k0p85083ij20d38oceg5",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "azamirugsd1aa27cd3a7a49e19234d2b0adc6db8f183234-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
